import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn, DateTimeColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('SITE EXIT', 'siteExit'),
        new TextColumn('SITE ENTRY', 'siteEntry'),
        new DateTimeColumn('EXIT DAY (UTC)', 'exitDay'),
        new DateTimeColumn('ENTRY DAY (UTC)', 'entryDay'),
        new TextColumn('PART', 'part'),
        new TextColumn('TRIP', 'trip'),
      ],
    },
  ];
};
